import { useState, useEffect, useContext } from 'react'
import classNames from 'classnames'
import Modal from 'react-modal'

import './shareModal.css'
import { useProject } from '../project/hook'
import { useTranslator } from '../translator/hook'
import CopyIcon from '../buttons/icons/copyIcon'
import CommunityIcon from '../buttons/icons/communityIcon'
import CloseIcon from '../buttons/icons/closeIcon'
import { toast } from 'react-toastify'
import { UserContext } from '../user/provider'

type ShareModalProps = {
  isOpen: boolean
  onClose: () => void
}

export const ShareModal = ({ onClose, isOpen }: ShareModalProps) => {
  const { title } = useProject()
  const { isOnlineUser } = useContext(UserContext)
  const { t } = useTranslator()
  const [clickCopyBtn, setClickCopyBtn] = useState(false)
  const [clickCommunityBtn, setClickCommunityBtn] = useState(false)

  const [animationClass, setAnimationClass] = useState('')

  useEffect(() => {
    if (isOpen) {
      setAnimationClass('share-modal-open')
    } else {
      setAnimationClass('share-modal-close')
    }
  }, [isOpen])

  const shareLink = `${window.location}`
  const apiEndpoint =
    isOnlineUser ?
      import.meta.env.VITE_DIGITANE_ONLINE_URL
    : import.meta.env.VITE_DIGITANE_LICENSE_URL
  const communityLink = `${apiEndpoint}/community/?course=robcratch&url=${window.location.href}&title=${title}`

  const onClickCopy = () => {
    navigator.clipboard.writeText(shareLink)
    toast.success(t('shared_url_copied'))
  }

  return (
    <Modal
      isOpen={isOpen}
      className={`share-modal-content ${animationClass}`}
      overlayClassName={`share-modal-overlay ${isOpen ? 'share-modal-overlay-show' : 'share-modal-overlay-hide'}`}
      onRequestClose={onClose}
      ariaHideApp={false}
    >
      <div className="share-modal-header">
        <div className="share-modal-header-text">{t('shared')}</div>
        <CloseIcon className="share-modal-close-button" onClick={onClose} />
      </div>
      <div className={'share-modal-body'}>
        <div className={'share-modal-link-wrapper'}>
          リンク
          <br />
          <input
            className={'share-modal-link'}
            type="text"
            value={shareLink}
            disabled
          />
        </div>
        <button
          className={classNames('share-modal-btn', 'share-modal-copy-btn', {
            ['share-modal-clicked-btn']: clickCopyBtn,
          })}
          onMouseDown={() => setClickCopyBtn(true)}
          onMouseUp={() => setClickCopyBtn(false)}
          onClick={onClickCopy}
        >
          <CopyIcon className="share-modal-content-icon" />
          <span>リンクをコピー</span>
        </button>
        <div className={'share-modal-message'}>
          {t('lets_post_to_community')}
        </div>
        <a
          href={communityLink}
          className={'share-modal-community-btn-wrapper'}
          target="_blank"
          rel="noopener noreferrer"
        >
          <button
            className={classNames(
              'share-modal-btn',
              'share-modal-community-btn',
              {
                ['share-modal-clicked-btn']: clickCommunityBtn,
              },
            )}
            onMouseDown={() => setClickCommunityBtn(true)}
            onMouseUp={() => setClickCommunityBtn(false)}
            onClick={() => {
              onClose()
            }}
          >
            <CommunityIcon className="share-modal-content-icon" />
            <span className="share-modal-btn-label">
              {t('post_to_community')}
            </span>
          </button>
        </a>
      </div>
    </Modal>
  )
}
